<template>
    <div class="StoresDetail mx-auto my-2">
        <Nav></Nav>
        <div id="loading" v-if="showLoading">
            <img
            class="loadingImg"
            src="../../assets/images/loading.gif"
            alt="loading..."
            width="200"
            />
        </div>
        <div class="storeData d-flex flex-column">
            <div>
                <h3 class="text-center">特約商店-<span class="text-primary">{{storeData.name}}</span></h3>
                <div class="border-top border-primary"></div>
                <p>&nbsp;</p>
            </div>
            <div>
                <div class="p-3 border bg-light text-light">
                <p class="text-center"><img class="img-fluid" v-bind:src="storeData.storePhotoUri" /></p>
                </div>
                <p>&nbsp;</p>
                
                <div class="border-top border-primary"></div>
                    <ul class="nav nav-pills">
                    <li class="col-6 btn btn-link" @click="tabSwitch(1)" :class="{'font-weight-bolder':isNormal}"><font-awesome-icon :icon="['far', 'star']" />　優惠資訊</li>
                    <li class="col-6 btn btn-link" @click="tabSwitch(2)" :class="{'font-weight-bolder':isNormal2}"><font-awesome-icon :icon="['far', 'paper-plane']" />　商店資訊</i></li>
                    </ul>
                <div class="border-top border-primary"></div>
                <div id="tab1" class="tabs" v-show="tabok">
                <h4 class="font-weight-bolder my-3">優惠資訊：</h4>
                <p>&nbsp;</p>
                <div v-html="storeData.specialOffer"></div>
                </div>
                <div id="tab2" class="tabs" v-show="tabok2">
                    <h4 class="font-weight-bolder my-3">商店資訊：</h4>
                    <p>&nbsp;</p>
                    <div class="" v-for="info in storeData.storeInfo">
                        <p v-if="info.storeInfoTypeId == 3">{{info.infoTypeName}} ： <a :href="info.url" target="_blank">{{info.content}}</a></p>
                        <p v-if="info.storeInfoTypeId != 3">{{info.infoTypeName}} ： {{info.content}}</p>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Nav from '@/components/Nav'
import {app} from '@/main'
import Vue from 'vue'
import axios from 'axios'
import moment from 'moment'

export default {
    name: 'StoresDetail',
    components:{
        Nav,
    },
    data () {
        return {
            showLoading:'',
            storeData:{},
            memberStoresInfo:[],
            StoresId:'',
            tabok : true,
            tabok2: false,
            isNormal: true,
            isNormal2: false,
        }
    },
    methods:{
        unescape(str) {
            const div = document.createElement('div');
            div.innerHTML = str;
            return div.textContent;
        },
        tabSwitch(divId){
            this.tabok     = divId == 2 ? false : true;
            this.tabok2    = divId == 2 ? true : false;
            this.isNormal  = divId == 1 ? true : false;
            this.isNormal2 = divId == 2 ? true : false;
        },
        GetStoresDetailData(){
            this.showLoading = true;

            const api =`${process.env.APIPATH}/api/ContractedStores/GetStoreDetail`;
            const inputdata = 
            {
                "storeId":this.storeId
            };

            axios.post(api, inputdata)
                .then((response) => {
                    this.showLoading = false;
                    if(response.data.isSuccess){ 
                        this.storeData = response.data.store[0]
                    }else{
                        console.error("There was an error!", response.data.message);
                    }
                })
                .catch(error => {
                    this.showLoading = false;
                    this.errorMessage = error.message;
                    console.error("There was an error!", error);
                });
        }
    },
    created(){
        this.storeId = this.$route.params.storeId;
        this.GetStoresDetailData();
    },
}
</script>






// WEBPACK FOOTER //
// src/components/line/StoresDetail.vue